// src/pages/LandingPage.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessment } from '../contexts/AssessmentContext';
import { logo1, logo2, logo3, logo4, bg, icon1, icon2, icon3 } from '../assets';

import {
  Box,
  Container,
  Typography,
  Button
} from '@mui/material';

import {
  AdminPanelSettings as AdminIcon,
  Logout as LogoutIcon,
  Login as LoginIcon,
  Info as InfoIcon
} from '@mui/icons-material';

export default function LandingPage() {
  const navigate = useNavigate();
  const { clearAssessmentData } = useAssessment();

  const [adminUser, setAdminUser] = useState(null);

  useEffect(() => {
    const adminData = sessionStorage.getItem('adminUser');
    if (adminData) setAdminUser(JSON.parse(adminData));
  }, []);

  const handleStartAssessment = () => {
    sessionStorage.removeItem('assessmentData');
    sessionStorage.removeItem('sessionToken');
    sessionStorage.removeItem('assessmentId');
    sessionStorage.removeItem('lastQuestionsSessionToken');

    clearAssessmentData();
    navigate('/register');
  };

  const handleAdminLogin = () => navigate('/admin/login');
  const handleUserLogin = () => navigate('/user/login');
  const handleAdminPanel = () => navigate('/admin/dashboard');

  const handleAdminLogout = () => {
    sessionStorage.removeItem('adminUser');
    setAdminUser(null);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: 'Helvetica, Arial, sans-serif' }}>

      {/* HEADER WITH LOGOS */}
      <div style={{ backgroundColor: 'white', padding: '16px 0', boxShadow: '0px 2px 4px rgba(0,0,0,0.1)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            {/* LEFT SIDE - LOGOS */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
              <div style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                <img
                  src={logo1}
                  alt="Government of Telangana"
                  style={{
                    height: '45px',
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>

              <div style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                <img
                  src={logo2}
                  alt="Telangana Rising"
                  style={{
                    height: '45px',
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>

              <div style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                <img
                  src={logo3}
                  alt="AIKAM"
                  style={{
                    height: '45px',
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>

              <div style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                <img
                  src={logo4}
                  alt="The Dialogue"
                  style={{
                    height: '45px',
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
            </div>

            {/* RIGHT SIDE - LOGIN BUTTONS */}
            <div style={{ display: 'flex', gap: '16px' }}>
              {adminUser ? (
                <>
                  <button
                    onClick={handleAdminPanel}
                    style={{
                      color: '#333',
                      fontWeight: 500,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      backgroundColor: 'transparent',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    Admin Panel
                  </button>
                  <button
                    onClick={handleAdminLogout}
                    style={{
                      color: '#333',
                      fontWeight: 500,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      backgroundColor: 'transparent',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={handleUserLogin}
                    style={{
                      color: '#333',
                      fontWeight: 500,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      backgroundColor: 'transparent',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    User Login
                  </button>
                  <button
                    onClick={handleAdminLogin}
                    style={{
                      color: '#333',
                      fontWeight: 500,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      backgroundColor: 'transparent',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    Admin Login
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 24px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '64px' }}>

          {/* LEFT DIV - TEXT CONTENT */}
          <div style={{ flex: 1 }}>
            <h1 style={{
              fontFamily: 'Helvetica',
              fontWeight: 300,
              marginBottom: '16px',
              fontSize: '60px',
              lineHeight: '1.2',
              color: '#000000',
              margin: '0 0 16px 0'
            }}>
              RAISE Index<br/>
              Assessment Tool
            </h1>

            <p style={{
              fontFamily: 'Helvetica',
              marginBottom: '32px',
              fontWeight:400,
              color: '#000000',
              fontSize: '18px',
              lineHeight: '1.5',
              margin: '0 0 32px 0'
            }}>
              Evaluate your AI system's responsibility and ethical compliance
            </p>

            {/* START ASSESSMENT BUTTON + TEXT */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '48px' }}>
              <button
                onClick={handleStartAssessment}
                style={{
                  backgroundColor: '#004494',
                  color: 'white',
                  width: '205px',
                  height: '70px',
                  padding: '24px',
                  fontSize: '16px',
                  fontWeight: 400,
                  fontFamily: 'Helvetica',
                  borderRadius: '56px',
                  border: 'none',
                  cursor: 'pointer',
                  boxShadow: '0px 4px 12px rgba(0, 68, 148, 0.3)', // Updated shadow color
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease',
                  outline: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#003366'; // Darker blue for hover
                  e.target.style.boxShadow = '0px 6px 16px rgba(0, 68, 148, 0.4)'; // Updated shadow color
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#004494'; // Back to theme color
                  e.target.style.boxShadow = '0px 4px 12px rgba(0, 68, 148, 0.3)'; // Updated shadow color
                }}
              >
                Start Assessment
              </button>

              {/* SECURITY NOTE */}
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                <InfoIcon sx={{ fontSize: 18, color: '#000', mt: 0.2 }} />

                <p style={{
                  fontFamily: 'Helvetica',
                  fontSize: '12px',
                  fontWeight: 400,
                  color: '#000000',
                  maxWidth: '420px',
                  lineHeight: '1.4',
                  textAlign: 'justify',
                  margin: 0
                }}>
                  Your data is secure. All information provided is kept strictly confidential. We use industry‑standard encryption and do not share your data with third parties.
                </p>
              </div>
            </div>

            {/* FEATURE CARDS */}
            <div style={{ display: 'flex', gap: '24px', maxWidth: '600px', alignItems:'left' }}>
              {[{
                icon: icon1,
                title: "Industry Standard",
                text: "Based on established AI ethics frameworks"
              },
              {
                icon: icon2,
                title: "Secure & Private",
                text: "Transparent, reliable scoring methodology"
              },
              {
                icon: icon3,
                title: "Actionable Insights",
                text: "Get clear guidance on how to improve"
              }].map((item, i) => (
                <div key={i} style={{
                  width: '200px',
                  height: '160px',
                  borderRadius: '16px',
                  padding: '16px',
                  backgroundColor: 'white',
                  boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'left',
                  textAlign: 'left'
                }}>
                  <img src={item.icon} style={{ width: '40px', height: '40px', marginBottom: '16px',  alignSelf: 'flex-start'}} alt={item.title} />
                  <div>
                    <h3 style={{
                      fontFamily: 'Helvetica',
                      fontSize: '16px',
                      fontWeight: 500,
                      marginBottom: '8px',
                      color: '#000',
                      margin: '0 0 8px 0'
                    }}>
                      {item.title}
                    </h3>

                    <p style={{
                      fontFamily: 'Helvetica',
                      fontSize: '14px',
                      color: '#000',
                      textAlign: 'justify',
                      margin: 0,
                      lineHeight: '1.3',
                      fontWeight: 300
                    }}>
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT DIV - BACKGROUND IMAGE */}
          <div style={{ 
            flex: 1,
            display: 'flex', 
            justifyContent: 'center',
            alignItems: 'flex-start',
            paddingTop: '32px'
          }}>
            <img
              src={bg}
              alt="RAISE Index Assessment"
              style={{
                width: '110%',
                maxWidth: '1200px',
                height: 'auto',
                marginLeft:'63px',
                // borderRadius: '20px',
                // boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
                objectFit: 'cover',
                // marginRight:'-100px'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}